// Клиент нашего API (вместо Firebase).
// В разработке запросы на /api и /uploads проксируются на localhost:4000 (см. "proxy" в package.json).

const TOKEN_KEY = "rr_admin_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* приватный режим — просто не запоминаем */
  }
  window.dispatchEvent(new Event("rr:auth"));
};

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

export async function api(path, { method = "GET", body, form, signal } = {}) {
  const headers = {};
  const token = getToken();
  if (token) headers.authorization = `Bearer ${token}`;
  if (body !== undefined) headers["content-type"] = "application/json";

  let res;
  try {
    res = await fetch(`/api${path}`, {
      method,
      headers,
      signal,
      body: form || (body !== undefined ? JSON.stringify(body) : undefined),
    });
  } catch (err) {
    if (err.name === "AbortError") throw err;
    throw new ApiError(0, "Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.");
  }

  if (res.status === 204) return null;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    if (res.status === 401 && token && path.startsWith("/admin")) setToken(null);
    throw new ApiError(res.status, data?.error || `Ошибка сервера (${res.status})`);
  }
  return data;
}

// Публичные запросы сайта
export const publicApi = {
  properties: ({ limit = 9, offset = 0, recommended } = {}) =>
    api(`/properties?limit=${limit}&offset=${offset}${recommended ? "&recommended=1" : ""}`),
  property: (id) => api(`/properties/${encodeURIComponent(id)}`),
  posts: ({ limit = 9, offset = 0, category } = {}) =>
    api(`/posts?limit=${limit}&offset=${offset}${category ? `&category=${encodeURIComponent(category)}` : ""}`),
  post: (id) => api(`/posts/${encodeURIComponent(id)}`),
  viewPost: (id) => api(`/posts/${encodeURIComponent(id)}/view`, { method: "POST" }).catch(() => {}),
  page: (id) => api(`/pages/${encodeURIComponent(id)}`),
};

// Выбор текста под язык: английский, если заполнен, иначе русский
export const localized = (lang, ru, en) => (lang === "en" && en ? en : ru || "");
